module.exports = __webpack_public_path__ + "static/media/unevenhip_mild_left.ee7c88ad.png";